import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useContactEngagement = (params, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('contacts/engagement/'), {
            ...additional,
            params
        }),
        queryKey: contactKeys.engagement(params.profile_id, params),
        enabled
    });
};
export default useContactEngagement;
